import { Divider, IconButton, Stack } from "@mui/material";
import { ReactComponent as Edit } from "../../../../Assets/Images/EditOutlined.svg";
import { Heading3 } from "../../../atoms/Typography/Heading/Heading";
import { Text8 } from "../../../atoms/Typography/Text/Text";

export const DcsView = ({ t, data, setContentID, reset, text, type }) => {
  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        marginBottom={"16px"}
      >
        <Stack direction={"column"}>
          <Heading3 text={text} />
          <Text8 text={t("glossary:consultation-rate:subject-goverment")} />
        </Stack>
        <Stack direction={"row"} spacing={2} alignItems={"center"}>
          <Heading3
            text={`Rs. ${data?.value} per consultation`}
          />
          <IconButton style={{ padding: 0 }}>
            <Edit
              role="img"
              type="img"
              aria-label="Edit Icon"
              style={{ width: "20px", height: "20px" }}
              onClick={() => {
                setContentID({
                  sceneID: 1,
                  isUpdate: !!data,
                  id: data?.id || "",
                });
                reset({
                  fee: data?.value.toString() || "",
                });
              }}
            />
          </IconButton>
        </Stack>
      </Stack>
      <Divider style={{ width: "100%", marginBottom: "20px" }} />
    </>
  );
};